const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/api/auth/login',
  FORGOT_PASSWORD: '/api/auth/forgot-password',
  RESET_PASSWORD: '/api/auth/reset-password',
  REFRESH: '/api/auth/refresh',
  PROFILE: '/api/auth/profile',
  USAGE: '/api/auth/usage',

  // RIS
  // Routes 2.0-shaped requests through the RISearch 2.5 (v25) pipeline:
  // pure-HTTP RIS tools (no nested-Gemini timeouts), same blocking JSON response
  // shape as /tooluse. Streaming SSE UI is a follow-up; /tooluse remains as fallback.
  RIS_TOOLUSE: '/api/ris/v25/compat',
  RIS_VIEWER: '/api/ris/viewer',
  RIS_SESSIONS: '/api/ris/sessions',
  RIS_SESSION_HISTORY: '/api/ris/session',
  RIS_SESSION_RESTORE: '/api/ris/session',

  // Admin
  ADMIN_USERS: '/api/admin/users',
  ADMIN_TENANTS: '/api/admin/tenants',
  ADMIN_LOGS: '/api/admin/logs',
  ADMIN_METRICS: '/api/admin/metrics',

  // Support
  SUPPORT_TICKETS: '/api/support/tickets',
};

export function buildApiUrl(endpoint: string, id?: string): string {
  const fullPath = id ? `${endpoint}/${id}` : endpoint;
  return `${API_BASE_URL}${fullPath}`;
}

export default API_BASE_URL;
